import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-un-authorize',
  templateUrl: './un-authorize.component.html',
  styleUrls: ['./un-authorize.component.scss']
})
export class UnAuthorizeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
